import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { Card, Col, FormGroup, Row } from 'reactstrap'
import { Constants } from 'src/Constants'
import { imageUpload } from 'src/services/BannersServices'

interface Props {
    testimony?: any
    handleDelete?: (id: number) => void
    newTestimony?: any
    setNewTestimony?: any
    handleAdd?: () => void
}


const Rating = ({testimony, handleDelete, newTestimony, setNewTestimony, handleAdd}: Props) => {

  const handleAcceptedFiles = async (files: any, hook: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "rating",
        });
        setNewTestimony({...newTestimony, image: response.data.data.image})
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };


  return (
    <div style={{display: 'flex', alignItems: 'center'}} className="row">
    <div className="col-8" key={testimony?.id}>
        <div className="card">
                <div className='card-header'>
                {
                    testimony?.id ?
                        testimony.image ? <img src={testimony?.image} alt={testimony.name} className="card-avatar" /> :
                        <img src="https://www.gravatar.com/avatar/?d=mp" alt={testimony.name} className="card-avatar" /> :
                    <Col md={4}>
                    <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                        <Dropzone
                        onDrop={(acceptedFiles) => {
                            handleAcceptedFiles(acceptedFiles, "image");
                        }}
                        >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                            <div
                                className="dz-message needsclick mt-2"
                                {...getRootProps()}
                            >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>Drop files here or click to upload.</h4>
                            </div>
                            </div>
                        )}
                        </Dropzone>
                        <div className="dropzone-previews mt-3" id="file-previews">
                        {newTestimony?.image && (
                            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                            <div className="p-2">
                                <Row className="align-items-center">
                                <Col className="col-auto">
                                    <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt=""
                                    src={`${Constants.BASE_URL}${newTestimony?.image}`}
                                    />
                                </Col>
                                </Row>
                            </div>
                            </Card>
                        )}
                        </div>
                    </FormGroup>
                    </Col>
                }
                <span className='col-md-4 pt-2'>
                    {
                        testimony?.id ? <h5 style={{fontSize: 16, marginBottom: 0}}>{testimony?.name}</h5> :
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre"
                            value={newTestimony?.name}
                            required
                            onChange={(e) => setNewTestimony({...newTestimony, name: e.target.value})}
                        />
                    }
                    {
                        testimony?.id ? <p style={{color: 'gray', fontSize: 14}}>{new Date(testimony?.created_at).toLocaleDateString('de-DE',  {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'})}</p> :
                        <input
                            type="date"
                            className="form-control mt-2"
                            placeholder={new Date().toLocaleDateString('de-DE',  {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'})}
                            value={newTestimony?.created_at}
                            onChange={(e) => setNewTestimony({...newTestimony, created_at: e.target.value})}
                        />
                    }
                </span>
                </div>
                <div className="card-body">
                <div className='stars'>
                {
                    testimony?.rating ?
                    Array.from({length: 5}, (_, i) => (
                    i < testimony?.rating ?
                        <i style={{color: '#F1C40F'}} className="bi bi-star-fill" key={i}></i>
                        :
                        <i className="bi bi-star" key={i}></i>
                    )) :
                    <input required className='form-control mb-2' style={{width: '100px'}} type="number" placeholder='Rating' min={0} max={5} value={newTestimony?.rating} onChange={(e) => setNewTestimony({...newTestimony, rating: e.target.value})} />
                }
                </div>
                {
                    testimony?.id ? <p className="card-text">{testimony?.description}</p> :
                    <textarea
                        className="form-control"
                        placeholder="Descripcion"
                        value={newTestimony?.description}
                        onChange={(e) => setNewTestimony({...newTestimony, description: e.target.value})}
                        required
                    >
                    </textarea>
                }
                </div>
            </div>
        </div>
        {
            testimony?.id ?
                <div className="col-2 text-right gap-2 d-flex justify-content-center flex-column">
                    {
                    /*
                    <button
                        className="btn btn-primary"
                    >
                        Editar
                    </button>
                        */
                    }
                    <button
                    className="btn btn-danger"
                    onClick={() => handleDelete && handleDelete(testimony?.id)}
                    >
                    Eliminar
                    </button>
                </div> : null
        }
        </div>
  )
}

export default Rating